import Vue from "vue";
import { VueSvgIcon } from "@yzfe/vue-svgicon";
import "@yzfe/svgicon/lib/svgicon.css";

Vue.component("icon", VueSvgIcon);
